import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdShareclassNameTicker extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col-left col-fund-name'
      onClick={this.props.clickShareclass(this.props.shareclass)}
    >
      <div styleName='table-fund-name'>
        {this.props.shareclass.fund_legal_name}
      </div>
      <div styleName='table-fund-ticker'>
        {this.props.shareclass.ticker || ''}
      </div>
    </td>
  }
}